var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block.platform == 1)?_c('SlideCategoriesDesktop',{attrs:{"block":_vm.block,"relative-viewport":_vm.relativeViewport}}):_c('SlidCategoriesMobile',{attrs:{"block":_vm.block}})
}
var staticRenderFns = []

export { render, staticRenderFns }